<div class="position-relative" [formGroup]="formGroup">
  <app-phone-country-code-dropdown-input [formControlName]="countryCodeControlName" [countryDropdowns]="countryCodes" />
  <app-phone-country-code-number-input
    [formControlName]="phoneNumberControlName"
    [controlId]="controlId"
    [countryCode]="formGroup.controls[countryCodeControlName].value"
    [error]="error" />
</div>
